import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr, ADD, EDIT, VIEW } from '../../../common/common';
import LevelChoose from '../../Components/LevelChoose';
import Participate from '../../Components/Participate';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .timesheet': {
        '& .textFieldHalf': {
            width: '45%',
            marginRight: '30px',
        },
        '& .textFieldHalf2': {
            width: '30%',
            marginRight: '10px',
        },
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .title2': {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#212C31',
        marginBottom: '10px',
    },
    '& .title3': {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#212C31',
        marginBottom: '10px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class AddMatter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            case_id: "",
            name: "",
            number: "",
            numberCopy: "",
            note: "",
            timesheetNote: "",

            casesData: [],
            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            case_id,
            name,
            number,
            note,
            casesData,
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                <div className="title">Case Info</div>
                <TextField
                    disabled={this.isDisabled()}
                    id="attorney"
                    select
                    label="Case"
                    className="textField"
                    value={case_id}
                    onChange={e => this.handleSelect(e, "case_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {casesData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.number}
                        </MenuItem>
                    ))}
                </TextField>
                <div className="title">Matter Info</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="number"
                    label="New Matter Number"
                    value={number}
                    onChange={e => this.handleChange(e, 'number')}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="name"
                    label="New Matter Name"
                    value={name}
                    onChange={e => this.handleChange(e, 'name')}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="notes"
                    label="Matter Notes"
                    multiline
                    rows="3"
                    value={note}
                    onChange={e => this.handleChange(e, 'note')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Originating Department / Team / Attorney</div>
                <LevelChoose
                    ref={(child) => { this.levelChoose = child }}
                    officeName={this.getHandleData("office")}
                    deptId={this.getHandleData("dept")}
                    teamId={this.getHandleData("team")}
                    memberId={this.getHandleData("member")}
                    state={this.props.state}
                    isDisabled={this.isDisabled()}
                />
                <div className="title">Participants</div>
                <Participate
                    ref={(child) => { this.participate = child }}
                    userList={this.userFormat()}
                    state={this.props.state}
                    addBtnName="add another participant"
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.getCase();
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const {
            case_id,
            number,
            numberCopy,
            name,
            note,
        } = this.state;

        let teamObj = this.levelChoose.getData();
        let userObj = {};
        userObj.handler_id = teamObj.handler_id;
        userObj.handler_team_id = teamObj.handler_team_id;
        userObj.is_origin_attorney = true;
        const attorneyArr = [userObj];
        const asObjFormat = this.editAttorney(attorneyArr);//结构：{addHandler,delHanlder}
        const psObjFormat = this.participate.getData();//结构：{addMembers,delMembers}
        const handlers = this.mergeHandlers(asObjFormat, psObjFormat);

        let obj = {
            case_id,
            number: (number !== numberCopy) ? number : null,
            name,
            note,
            handlers
        }
        console.log(obj)
        this.props.handleCreate(obj);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //name和desc输入的内容
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const userObj = handlers[0].user;
        const deptObj = handlers[0].team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.matter[0].handler;
        console.log(data)
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
    mergeHandlers(attorneyArr, participantArr) {
        const aAddMembers = attorneyArr.addHandler;
        const pAddMembers = participantArr.addMembers;
        const aDelMembers = attorneyArr.delHandler;
        const pDelMembers = participantArr.delMembers;
        const addMembers = aAddMembers.concat(pAddMembers);
        const delMembers = aDelMembers.concat(pDelMembers);
        return { addMembers, delMembers };
    }
    editAttorney(handler) {
        const addHandler = handler;
        const delHandler = this.extDelAttorney();
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = (delHandler.length > 0) ? delHandler[0].handler_id : "";
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = (delHandler.length > 0) ? delHandler[0].handler_team_id : "";
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                return { addHandler: [], delHandler: [] };
            } else {
                return { addHandler, delHandler }
            }
        }
    }
    extDelAttorney() {
        const { data } = this.props;
        if (!data) return [];
        const handlers = data.matter[0].handler;
        if (!handlers) return [];
        let handlerObj = [];
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                let newObj = {};
                newObj.handler_id = obj.user.id;
                newObj.handler_team_id = obj.team.id;
                newObj.is_origin_attorney = obj.is_origin_attorney;
                handlerObj.push(newObj);
                return handlerObj;
            }
        }
        return [];
    }
    //----------------request-------------------------------
    getCase() {
        let params = {
            // origin_attorney_id,
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + roleStr() + '/cases', { params }).then((res) => {
            const casesData = res.data.data;
            console.log(casesData)
            this.setState(() => ({
                casesData,
            }));
        })
    }
}

export default AddMatter;